import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import Sidebar from 'components/Sidebar';
import SidebarGroup from 'components/Sidebar/SidebarGroup';
import SidebarGroupItem from 'components/Sidebar/SidebarGroup/SidebarGroupItem';
import { getMagazineArticlesOnSidebar } from 'selectors';

class MagazineArticleSidebar extends Component {

  renderMagazineArticles(magazineArticles) {
    return magazineArticles.map(magazineArticle => {
      return (
        <SidebarGroupItem
          key={magazineArticle.id}
          title={magazineArticle.title}
          authorName={magazineArticle.author.userName}
          authorAvatarUrl={magazineArticle.author.avatar.url}
          articleUrl={`/magazine/articles/${magazineArticle.id}`}
        />
      );
    });
  }

  renderMagazineArticlesGroups(magazineArticlesGroups) {
    return magazineArticlesGroups.map(magazineArticlesGroup => {
      const { magazineArticles } = magazineArticlesGroup;

      return (
        <SidebarGroup key={magazineArticlesGroup.title} title={magazineArticlesGroup.title}>
          {this.renderMagazineArticles(magazineArticles)}
        </SidebarGroup>
      );
    });
  }

  render() {
    return (
      <Sidebar isWider={this.props.isWider}>
        {this.renderMagazineArticlesGroups(this.props.magazineArticlesGroups)}
      </Sidebar>
    );
  }
}

MagazineArticleSidebar.propTypes = {
  queries: PropTypes.object,
  selectedQueryString: PropTypes.string,
  magazineArticlesGroups: PropTypes.array,
  isWider: PropTypes.bool
};

const mapStateToProps = (state, props) => {
  const magazineArticlesGroups = [];

  Object.keys(props.queries).forEach(key => {
    const queryString = JSON.stringify({...props.queries[key].query});
    const title = props.queries[key].title;

    if(queryString !== props.selectedQueryString) {
      const allMagazineArticles = getMagazineArticlesOnSidebar(state, { page: 1, queryString });
      const magazineArticles = allMagazineArticles.slice(0, Math.min(3, allMagazineArticles.length));

      if(magazineArticlesGroups.length < 2 && magazineArticles.length > 0) {
        magazineArticlesGroups.push({
          title,
          magazineArticles
        });
      }
    }
  });

	return {
    magazineArticlesGroups
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MagazineArticleSidebar);



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/MagazineArticlesSidebar/index.js
 **/